import api from './authService';

export interface SosEligibility {
  isEligible: boolean;
  eligibleEventIds: string[];
  eligibleEventNames: string[];
  reason: string;
}

export interface SosAccessResponse {
  isGranted: boolean;
  message: string;
  eligibleEventNames: string[];
}

export interface SosAccessReportFilter {
  coachUserId?: string;
  viewedUserId?: string;
  startDate?: string;
  endDate?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface SosAccessReportItem {
  sosAccessLogId: number;
  accessedAt: string;
  coachName: string;
  viewedUserName: string;
  eventName: string;
  ipAddress: string;
}

export interface PagedResult<T> {
  data: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export const sosAccessService = {
  /**
   * Check if coach is eligible to use SOS for viewing a user's data
   */
  async checkEligibility(userId: string): Promise<SosEligibility> {
    const response = await api.get(`/sos-access/eligibility/${userId}`);
    return response.data;
  },

  /**
   * Grant SOS access and log it
   */
  async grantAccess(userId: string): Promise<SosAccessResponse> {
    const response = await api.post('/sos-access/grant', {
      viewedUserId: userId
    });
    return response.data;
  },

  /**
   * Get SOS access report (Admin only)
   */
  async getAccessReport(filter: SosAccessReportFilter): Promise<PagedResult<SosAccessReportItem>> {
    const response = await api.get('/sos-access/report', {
      params: filter
    });
    return response.data;
  }
};
